import axios from 'axios';
import * as Constants from '../constants'


const login = async (user) => {
    let result = await axios.post(Constants.APIURL, {
        token: localStorage.getItem('token'),
        mode: "login",
        username: user.username,
        password: user.password
    }, {
        headers: {
            'Content-Type': 'application/json;charset=UTF-8'
        }
    });
    return result.data;
}

const getUsers = async (sort, order,paginationParams,filterValue) => {
    let result = await axios.post(Constants.APIURL, {
        token: localStorage.getItem('token'),
        mode: "users",
        sort: sort,
        order: order,
        pageIndex: paginationParams.pageIndex,
        pageSize: paginationParams.pageSize,
        filterValue: filterValue
    }, {
        headers: {
            'Content-Type': 'application/json;charset=UTF-8'
        }
    });
    return result.data
}
const deleteUsers = async (users) => {
    let result = await axios.post(Constants.APIURL, {
        token: localStorage.getItem('token'),
        mode: "delete_users",
        users: users
    }, {
        headers: {
            'Content-Type': 'application/json;charset=UTF-8'
        }
    });
    return result.data;
}

const editUser = async (user) => {
    let result = await axios.post(Constants.APIURL, {
        token: localStorage.getItem('token'),
        mode: "edit_user",
        user: user
    }, {
        headers: {
            'Content-Type': 'application/json;charset=UTF-8'
        }
    });
    return result.data;
}

const newUser = async (user) => {
    let result = await axios.post(Constants.APIURL, {
        token: localStorage.getItem('token'),
        mode: "save_user",
        user: user
    }, {
        headers: {
            'Content-Type': 'application/json;charset=UTF-8'
        }
    });
    return result.data;
}

const inviaNotifica = async (idUtente, notifica) => {
    let result = await axios.post(Constants.APIURL, {
        token: localStorage.getItem('token'),
        mode: "send_notice",
        id_user: idUtente,
        notice: notifica
    }, {
        headers: {
            'Content-Type': 'application/json;charset=UTF-8'
        }
    });
    return result.data;
}

const newPausa = async (pausa) => {
    let result = await axios.post(Constants.APIURL, {
        token: localStorage.getItem('token'),
        mode: "save_pausa",
        pausa: pausa
    }, {
        headers: {
            'Content-Type': 'application/json;charset=UTF-8'
        }
    });
    return result.data;
}

const getUserTypes = async () => {
    let result = await axios.post(Constants.APIURL, {
        token: localStorage.getItem('token'),
        mode: "user_types",
    }, {
        headers: {
            'Content-Type': 'application/json;charset=UTF-8'
        }
    });
    return result.data;
}

const getVideos = async (idTipo) => {
    let result = await axios.post(Constants.APIURL, {
        token: localStorage.getItem('token'),
        mode: "videos",
        id_tipo: idTipo
    }, {
        headers: {
            'Content-Type': 'application/json;charset=UTF-8'
        }
    });
    return result.data;
}

const getPauses = async (idVideo) => {
    let result = await axios.post(Constants.APIURL, {
        token: localStorage.getItem('token'),
        mode: "pauses",
        id_video: idVideo
    }, {
        headers: {
            'Content-Type': 'application/json;charset=UTF-8'
        }
    });
    return result.data;
}

const deletePause = async (idPause) => {
    let result = await axios.post(Constants.APIURL, {
        token: localStorage.getItem('token'),
        mode: "delete_pause",
        id_pause: idPause
    }, {
        headers: {
            'Content-Type': 'application/json;charset=UTF-8'
        }
    });
    return result.data;
}

const getSessioniUtente = async (id) => {
    let result = await axios.post(Constants.APIURL, {
        token: localStorage.getItem('token'),
        mode: "sessioni_utente",
        id_utente: id
    }, {
        headers: {
            'Content-Type': 'application/json;charset=UTF-8'
        }
    });
    return result.data;
}

export {
    login,
    getUsers,
    deleteUsers,
    editUser,
    newUser,
    getUserTypes,
    getSessioniUtente,
    getVideos,
    newPausa,
    getPauses,
    deletePause,
    inviaNotifica
}
